/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../components/Menu'
import Table from '../../../components/CodesLists'

import { useNavigate } from 'react-router-dom'

import foodIcon from '../../../assets/svg/offIcon.svg'
import { get } from '../../../services/http'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

export default function index() {
  const [offCodes, setOffCodes] = useState('')
  const [offCodesCount, setOffCodesCount] = useState()
  const [totalPage, setTotalPage] = useState()
  const [name, setName] = useState()

  const navigate = useNavigate()
  document.title = 'کد تخفیف'

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/offs/create')
  }

  useEffect(() => {
    get(`/api/admin/offcode?token=${token}`).then(response => {
      setOffCodes(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setOffCodesCount(response.data.data.total)
    })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/offcode?page=${event.selected + 1}&token=${token}`)
    .then(respose => {
      setOffCodes(respose.data.data.docs)
      setTotalPage(respose.data.data.pages)
      setOffCodesCount(respose.data.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  const searchBtnHandler = () => {
    get(`/api/admin/offcode/search/${name}?token=${token}`)
    .then(response => {
      setOffCodes(response.data.data)
      setTotalPage(0)
      setOffCodesCount(response.data.data.length)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  const getAllDataHandler = () => {
    get(`/api/admin/offcode?token=${token}`)
      .then(response => {
        setOffCodes(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setOffCodesCount(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'offcode'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست تخفیف‌ها
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler}>ایجاد کد تخفیف</button>
            </div>
          </div>

          <div className="tablePart">
            <div className='search'>
              <label htmlFor="search">نام کد تخفیف : </label>
              <input type="text" onChange={e => setName(e.target.value)}/>
              <button onClick={searchBtnHandler} style={{ margin: '0 0 0 1em' }}>جستجو</button>
              <button onClick={getAllDataHandler}>دریافت کل اطلاعات</button>
            </div>
            <hr />
            <div className="title">
              <div className="right">
                تعداد کل تخفیف‌ها
              </div>
              <div className="left">
                {offCodesCount}
              </div>
            </div>

            <Table data={offCodes} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
